import { render, staticRenderFns } from "./StaffBars.vue?vue&type=template&id=f667c022&scoped=true"
import script from "./StaffBars.vue?vue&type=script&lang=js"
export * from "./StaffBars.vue?vue&type=script&lang=js"
import style0 from "./StaffBars.vue?vue&type=style&index=0&id=f667c022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f667c022",
  null
  
)

export default component.exports